import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-label-title-subtitle-alt',
  templateUrl: './label-title-subtitle-alt.component.html',
  styleUrls: ['./label-title-subtitle-alt.component.scss']
})
export class LabelTitleSubtitleAltComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
